import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import Toggle from '@/components/Toggle';
import { GearFillIcon } from '@/icons';
import { useWorksheetSettingContext } from './context';
const SettingToggleRow = ({
  isOn,
  onToggle,
  label,
  description
}: {
  isOn: boolean;
  onToggle: () => void;
  label: string;
  description: string;
}) => {
  return <div className="flex flex-col gap-3xs" data-sentry-component="SettingToggleRow" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx">
      <div className="flex items-center justify-between">
        <span className="text-body-lg-semibold text-default">{label}</span>
        <Toggle className="!mt-0 w-fit grow-0" isOn={isOn} setIsOn={onToggle} data-sentry-element="Toggle" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx" />
      </div>
      <span className={'text-caption-lg-regular text-alternative'}>
        {description}
      </span>
    </div>;
};
export const QuizWorksheetAdditionalSetting = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    additionalSetting,
    handleAdditionalSettingToggle
  } = useWorksheetSettingContext();
  const {
    addJoinCode,
    randomQuestionOrder,
    randomChoiceOrder
  } = additionalSetting;
  return <div className="flex flex-col gap-md" data-sentry-component="QuizWorksheetAdditionalSetting" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx">
      <div className="flex items-center gap-2xs">
        <GearFillIcon size="sm" fill={ICON_COLOR.assistive} data-sentry-element="GearFillIcon" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx" />
        <span className="text-body-lg-bold text-default">
          {t('common:quizWorksheet.additionalSetting')}
        </span>
      </div>
      <div className="flex flex-col gap-md rounded-md border border-opacity-assistive bg-neutral px-lg py-md">
        <SettingToggleRow label={t('common:quizWorksheet.addJoinCode.label')} description={t('common:quizWorksheet.addJoinCode.description')} isOn={addJoinCode} onToggle={() => handleAdditionalSettingToggle('addJoinCode')} data-sentry-element="SettingToggleRow" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx" />
        <SettingToggleRow label={t('common:quizWorksheet.randomQuestionOrder.label')} description={t('common:quizWorksheet.randomQuestionOrder.description')} isOn={randomQuestionOrder} onToggle={() => handleAdditionalSettingToggle('randomQuestionOrder')} data-sentry-element="SettingToggleRow" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx" />
        <SettingToggleRow label={t('common:quizWorksheet.randomChoiceOrder.label')} description={t('common:quizWorksheet.randomChoiceOrder.description')} isOn={randomChoiceOrder} onToggle={() => handleAdditionalSettingToggle('randomChoiceOrder')} data-sentry-element="SettingToggleRow" data-sentry-source-file="QuizWorksheetAdditionalSetting.tsx" />
      </div>
    </div>;
};